export * from './ICompanyDetailsStore'
export * from './CompanyDetailsStore'

export const CompanyDetailsStoreSymbol = Symbol.for('CompanyDetailsStore')
